export default __webpack_public_path__ + "3c59734916ccc475209a761bbea865b1.svg";